import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { AssetGroup } from '../entities/assets/assetgroup.entity';
import { CustomerAssetGroup } from '../entities/customers/customerassetgroup.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class CustomerAssetGroupService extends ODataEntityService<CustomerAssetGroup> {
  constructor(protected client: ODataClient) {
    super(client, 'CustomerAssetGroup', 'entities.customers.CustomerAssetGroup');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public assetGroup(entity: EntityKey<CustomerAssetGroup>): ODataNavigationPropertyResource<AssetGroup> {
    return this.entity(entity).navigationProperty<AssetGroup>('assetGroup');
  }
  public status(entity: EntityKey<CustomerAssetGroup>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<CustomerAssetGroup>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
